<template>
  <v-card>
    <v-toolbar
      color="secondary"
      dark
      dense
      flat
    >
      <v-spacer />
      <v-toolbar-title v-text="$t('animation.ontime.answers')" />
      <v-spacer />
    </v-toolbar>

    <v-card-text>
      <bar-chart
        style="height: 400px"
        :data="game.playerList"
        :datasets="datasets"
        :category-list="categoryList"
      />
    </v-card-text>
  </v-card>
</template>

<script>
import Helpers from 'src/utils/helpers'
import BarChart from './BarChart'

export default {
  name: 'BarChartCard',
  components: {
    BarChart,
  },
  props: {
    game: {
      type: Object,
      required: true,
    },
  },
  computed: {
    datasets () {
      return [
        {
          field: 'answerOne',
          label: this.$t('animation.ontime.questionOne'),
          backgroundColor: '#576A74',
        },
        {
          field: 'answerTwo',
          label: this.$t('animation.ontime.questionTwo'),
          backgroundColor: '#8A3E70',
        },
      ]
    },
    categoryList () {
      const messages = this.$i18n.messages[this.$i18n.locale]
      return Helpers.getKeyValueList(messages.animation.ontime.choiceList)
    },
  },
}
</script>
